import { PreLoadApi, Params, Versions, Configs } from '../interfaces/versions';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, of } from '@totvs/mingle/node_modules/rxjs';
import { tap, catchError } from '@totvs/mingle/node_modules/rxjs/operators';
import { get } from 'lodash-es';
import { HttpService } from 'src/app/core/http/http.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  checkLoaded: Subject<any> = new Subject<any>();
  config: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  isLoaded: boolean = false;

  get config$(): Observable<PreLoadApi> {
    return this.config.asObservable();
  }
  constructor(private http: HttpService) {}

  getParam(fileName: string): number {
    return get(this.getVersions(), [fileName]);
  }

  getParams(): Params {
    return get(this.config.getValue(), 'params');
  }

  getVersion(fileName: string): number {
    return get(this.getVersions(), [fileName]);
  }

  getVersions(): Versions {
    return get(this.config.getValue(), 'versions');
  }

  preLoad(): Observable<PreLoadApi> {
    // Retorna diretamente o mock sem tentar fazer requisição
    return of({
      versions: {},
      params: {},
      configs: {},
    });
  }

  getConfigs(): Configs {
    return get(this.config.getValue(), 'configs');
  }

  getConfig(configName: string): boolean {
    return get(this.getConfigs(), [configName]);
  }

  setPreLoadApi(content: PreLoadApi): void {
    this.config.next(content);
    this.isLoaded = true;
    this.checkLoaded.next(this.isLoaded);
  }
}
